import React from "react";
import {
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  Grid2,
} from "@mui/material";

const renderWeatherSelection = (weather, handleChange) => {
    return (
      <FormControl component="fieldset">
        <FormLabel component="legend">Weather was:</FormLabel>
        <RadioGroup
          aria-label="weather"
          name="weather"
          value={weather}
          onChange={handleChange}
        >
            <Grid2 size={3}>
          <FormControlLabel value="sunny" control={<Radio />} label="Sunny" />
            </Grid2>
            <Grid2 size={3}>
          <FormControlLabel value="cloudy" control={<Radio />} label="Cloudy" />
            </Grid2>
            <Grid2 size={3}>
          <FormControlLabel value="raining" control={<Radio />} label="Rainy" />
            </Grid2>
            <Grid2 size={3}>
          <FormControlLabel value="snowing" control={<Radio />} label="Snowy" />
            </Grid2>
        </RadioGroup>
      </FormControl>
    );
  };

  const renderWindSelection = (wind, handleChange) => {
    return (
      <FormControl component="fieldset">
        <FormLabel component="legend">Wind was:</FormLabel>
        <RadioGroup
          aria-label="wind"
          name="wind"
          value={wind}
          onChange={handleChange}
        >
          <FormControlLabel value="calm" control={<Radio />} label="Calm" />
          <FormControlLabel value="windy" control={<Radio />} label="Windy" />
          <FormControlLabel value="stormy" control={<Radio />} label="Stormy" />
        </RadioGroup>
      </FormControl>
    );
  };

  const renderAgentStaffSelection = (agent_staff, handleChange) => {
    return (
      <FormControl component="fieldset">
        <FormLabel component="legend">Agent Staff was:</FormLabel>
        <RadioGroup
          aria-label="agent_staff"
          name="agent_staff"
          value={agent_staff}
          onChange={handleChange}
        >
          <FormControlLabel value="polite" control={<Radio />} label="Polite" />
          <FormControlLabel value="rude" control={<Radio />} label="Rude" />
          <FormControlLabel value="nice" control={<Radio />} label="Nice" />
        </RadioGroup>
      </FormControl>
    );
  };

  const renderCheckInSelection = (check_in, handleChange) => {
    return (
      <FormControl component="fieldset">
        <FormLabel component="legend">Check In was:</FormLabel>
        <RadioGroup
          aria-label="check_in"
          name="check_in"
          value={check_in}
          onChange={handleChange}
        >
          <FormControlLabel value="tickets" control={<Radio />} label="Tickets" />
          <FormControlLabel value="scans" control={<Radio />} label="Scans" />
          <FormControlLabel value="other" control={<Radio />} label="Other" />
        </RadioGroup>
      </FormControl>
    );
  };

  export { renderWeatherSelection, renderWindSelection, renderAgentStaffSelection, renderCheckInSelection };
